module.exports = __webpack_public_path__ + "images/services/confluence-blog-preview.50d8da2ad64e3963ed92.svg";